import { render, staticRenderFns } from "./InfoAdvert.vue?vue&type=template&id=21f5a60e&scoped=true"
import script from "./InfoAdvert.vue?vue&type=script&lang=js"
export * from "./InfoAdvert.vue?vue&type=script&lang=js"
import style0 from "./InfoAdvert.vue?vue&type=style&index=0&id=21f5a60e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5a60e",
  null
  
)

export default component.exports